import React from 'react';
import cx from 'classnames';

import Breadcrumbs from '@magoosh/layouts/lib/breadcrumbs';
import { Breadcrumb } from '@magoosh/layouts/types';

import style from './style.module.scss';

interface Props {
  breadcrumbs?: Breadcrumb[];
  className?: string;
  style?: any;
}

const CardLayout: (React.FC<Props> & { Card: any }) = (props) => {
  return (
    <div className={cx(style.page, props.className)} style={props.style}>
      <div className="container">
        {props.breadcrumbs && <Breadcrumbs breadcrumbs={props.breadcrumbs} />}
        {props.children}
      </div>
    </div>
  );
};

CardLayout.Card = (props) => {
  return (
    <div className={cx(style.pageCard, props.className)} style={props.style}>
      {props.children}
    </div>
  );
};

export default CardLayout;
